var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveGoal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0312 7.57422L13.1211 12.25L17.0312 16.9531C17.332 17.3359 17.3047 17.8828 16.9219 18.1836C16.5391 18.4844 15.9922 18.457 15.6914 18.0742L12 13.6172L8.28125 18.0742C7.98047 18.457 7.43359 18.4844 7.05078 18.1836C6.66797 17.8828 6.64062 17.3359 6.94141 16.9531L10.8516 12.25L6.94141 7.57422C6.64062 7.19141 6.66797 6.64453 7.05078 6.34375C7.43359 6.04297 7.98047 6.07031 8.28125 6.45312L12 10.8828L15.6914 6.45312C15.9922 6.07031 16.5391 6.04297 16.9219 6.34375C17.3047 6.64453 17.332 7.19141 17.0312 7.57422Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveGoal);
export default __webpack_public_path__ + "static/media/remove-goal.97a0b88c1f1ad0b1fbcfec8261c551a8.svg";
export { ForwardRef as ReactComponent };